import { pharmaSend } from '../../../utils/PharmasendApi';
import { useState, useEffect } from 'react';

export default function useGetSalesTax(
	countryCode,
	stateCode,
	canFetch
) {
	const [salesTax, setSalesTax] = useState(0);
	const [isFetching, setIsFetching] = useState(false);
	const [error, setError] = useState(null);

	const getSalesTaxApi = async (countryCode, stateCode) => {
		setIsFetching(true);
		setError(null); // Reset error state before fetching new data
		try {
			const salesTaxData = await pharmaSend.post(
				'',
				{
					country: countryCode,
					state: stateCode,
				}
			);
			const tax = salesTaxData.data;
			setSalesTax(tax.rate || 0);
		} catch (err) {
			setSalesTax(0);
			setError('Failed to fetch sales tax.');
		} finally {
			setIsFetching(false);
		}
	};

	useEffect(() => {
		if (countryCode && stateCode && canFetch) {
			getSalesTaxApi(countryCode, stateCode);
		}
	}, [countryCode, stateCode, canFetch]);

	return {
		salesTax,
		isFetching,
		error,
	};
}
